import { ModuleSidebar } from '../../../../components/ui/ModuleSidebar';
import { ProductNavigation } from '../../../../components/ui/ProductNavigation';
import { findProductModule } from '../../../../components/ui/ProductNavigation/navigation-data';
import { CouponManagementPage } from './app/CouponManagementPage';
import styles from './Page.module.css';

const recruitmentModule = findProductModule('recruitment');

export function CouponManagementV1Page() {
  return <main className={styles.page}>
    <ProductNavigation defaultActive="招生营销" />
    <div className={styles.workspace}>
      <ModuleSidebar activeItem="优惠券管理" ariaLabel="招生营销导航" groups={recruitmentModule?.groups ?? []} />
      <section aria-label="优惠券管理页面">
        <h1 className={styles.visuallyHidden}>优惠券管理</h1>
        <CouponManagementPage />
      </section>
    </div>
  </main>;
}
